import {
  Alert as ChakraAlert,
  AlertIcon,
  AlertDescription,
  Box,
  CircularProgress,
  CloseButton,
  Flex,
  PropsOf,
  useDisclosure,
} from '@chakra-ui/react';
import type { AlertProps } from '@chakra-ui/react';
import React from 'react';

export const Alert: React.FC<
  { isClosable?: boolean; children: React.ReactElement } & PropsOf<
    typeof ChakraAlert
  >
> = ({ isClosable = false, children, ...alertProps }) => {
  const { isOpen: isVisible, onClose } = useDisclosure({
    defaultIsOpen: true,
  });
  return isVisible ? (
    <ChakraAlert
      {...{ ...alertProps, variant: alertProps.variant || 'subtle' }}
      w="100%"
      m="16px 0"
      borderRadius="lg"
    >
      <Flex w="100%">
        <AlertIcon />
        {children}
      </Flex>
      {isClosable && <CloseButton alignSelf="flex-end" onClick={onClose} />}
    </ChakraAlert>
  ) : null;
};

export const ActionableAlert: React.FC<
  { actionElement: React.ReactElement } & AlertProps
> = ({ actionElement, status, variant, borderRadius, ...alertProps }) => {
  return (
    <ChakraAlert
      {...alertProps}
      status={status}
      variant={variant || 'subtle'}
      borderRadius={borderRadius || '10px'}
    >
      <AlertIcon />
      <AlertDescription>{alertProps.children}</AlertDescription>
      <Box flexGrow={1} textAlign="right">
        {actionElement}
      </Box>
    </ChakraAlert>
  );
};

export const ProgressAlert: React.FC<AlertProps> = ({
  children,
  ...otherProps
}) => {
  return (
    <ChakraAlert {...otherProps} status="info">
      <CircularProgress size="18px" isIndeterminate mr="16px" />
      <AlertDescription>{children}</AlertDescription>
    </ChakraAlert>
  );
};
